import { defineStore } from "pinia";
import i18n from "@/localization/i18n";
import { ref, watch, computed } from "vue";
import Config from "@/common/config";
import de from "element-plus/es/locale/lang/de";
import en from "element-plus/es/locale/lang/en";
import es from "element-plus/es/locale/lang/es";

export const useLocaleStore = defineStore(
  "locale",
  () => {
    // State
    const locale = ref<string>();

    watch(locale, (newLocale) => {
      if (newLocale !== undefined) i18n.global.locale.value = newLocale;
    });

    const elementPlusLocalization = computed(() => {
      switch (locale.value) {
        case "de":
          return de;
        case "es":
          return es;
        default:
          return en;
      }
    });

    return { locale, elementPlusLocalization };
  },
  {
    persist: {
      key: Config.localeDataPersistKey,
    },
  },
);
